import { Pipe, PipeTransform } from '@angular/core';
import { CompanyDict } from '../data';
import { Department } from '../models';

@Pipe({ name: 'departmentFmt' })
export class DepartmentPipe implements PipeTransform {

    transform(obj: any): string {
        if (!obj) { return '- -'; }
        if (!obj.id) { return '- -'; }
        const company = CompanyDict[+obj.companyId];
        return `${obj.code} ${obj.name} - ${company}`;
    }

}

@Pipe({ name: 'simpleDepartmentFmt' })
export class SimpleDepartmentPipe implements PipeTransform {

    transform(obj: any): string {
        if (!obj) { return '- -'; }
        if (!obj.id) { return '- -'; }
        return `${obj.code} ${obj.name}`;
    }

}

@Pipe({ name: 'locationFmt' })
export class LocationPipe implements PipeTransform {
    transform(obj: Department): string {
        if (!obj) { return '- -'; }
        if (!obj.latitude && !obj.longitude) { return '- -'; }
        return `Lat: ${obj.latitude} \n Lng: ${obj.longitude}`;
    }

}

@Pipe({ name: 'locationLatLngFmt' })
export class LocationLatLngPipe implements PipeTransform {
    transform(obj: any): string {
        if (!obj) { return '- -'; }
        return `${obj} `;
    }

}

@Pipe({ name: 'simpleNameDepartmentFmt' })
export class SimpleNameDepartmentPipe implements PipeTransform {

    transform(obj: any): string {
        if (!obj) { return '- -'; }
        if (!obj.id) { return '- -'; }
        return `${obj.name}`;
    }

}

@Pipe({ name: 'departmentCodeFmt' })
export class DepartmentCodePipe implements PipeTransform {

    transform(obj: any): string {
        if (!obj) { return '- -'; }
        if (!obj.id) { return '- -'; }
        return obj.code;
    }

}

@Pipe({ name: 'departmentTypeFmt' })
export class DepartmentTypePipe implements PipeTransform {

    transform(obj: any): string {
        if (!obj) { return '- -'; }
        return `${obj.code} - ${obj.name}`;
    }

}
